import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Notification from './Notification';

const NotificationList = () => {
  const notifications = useSelector(state => state.notification);

  return (
    <NotificationWrapper>
      {notifications.map(notification => (
        <Notification
          key={notification.id}
          id={notification.id}
          content={notification.content}
          title={notification.title}
          variant={notification.variant}
          disappear={notification.disappear}
        />
      ))}
    </NotificationWrapper>
  );
};

export default NotificationList;

const NotificationWrapper = styled.div`
  width: 325px;
  position: fixed;
  right: 18px;
  top: 100px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
`;
